import Cookies from "js-cookie";
import { Navigate, Route, Routes } from "react-router-dom";

import AboutPage from "../pages/about/AboutPage";
import ChangePasswordPage from "../pages/auth/change_password/ChangePassword";
import LoginPage from "../pages/auth/login/LoginPage";
import RegisterPage from "../pages/auth/register/RegisterPage";
import Dashboard from "../pages/dashboard/Dashboard";
import JobAddPage from "../pages/dashboard/job/JobAddPage";
import JobEditPage from "../pages/dashboard/job/JobEditPage";
import JobListPage from "../pages/dashboard/job/JobListPage";
import ProfilePage from "../pages/dashboard/profile/ProfilePage";
import DetailPage from "../pages/detail/DetailPage";
import HomePage from "../pages/home/HomePage";
import JobPage from "../pages/job/JobPage";
import NotFoundPage from "../pages/NotFoundPage";

import { AuthProvider } from "../context/AuthContext";
import { JobProvider } from "../context/JobContext";
import LayoutDashboard from "../layouts/LayoutDashboard";
import LayoutMain from "../layouts/LayoutMain";

const AppRouter = () => {
  const DashboardRoute = ({ children }) => {
    if (!Cookies.get("token")) {
      return <Navigate to="/login" replace />;
    }
    return children;
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          <JobProvider>
            <LayoutMain>
              <HomePage />
            </LayoutMain>
          </JobProvider>
        }
      />
      <Route
        path="/job-vacancy"
        element={
          <LayoutMain>
            <JobProvider>
              <JobPage />
            </JobProvider>
          </LayoutMain>
        }
      />
      <Route
        path="/about"
        element={
          <LayoutMain>
            <AboutPage />
          </LayoutMain>
        }
      />
      <Route
        path="/detail/:id"
        element={
          <LayoutMain>
            <DetailPage />
          </LayoutMain>
        }
      />

      <Route
        path="/dashboard"
        element={
          <DashboardRoute>
            <JobProvider>
              <LayoutDashboard />
            </JobProvider>
          </DashboardRoute>
        }>
        <Route index element={<Dashboard />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route
          path="change-password"
          element={
            <AuthProvider>
              <ChangePasswordPage />
            </AuthProvider>
          }
        />
        <Route path="list-job-vacancy" element={<JobListPage />} />
        <Route path="list-job-vacancy/form" element={<JobAddPage />} />
        <Route
          path="list-job-vacancy/form/edit/:id"
          element={<JobEditPage />}
        />
      </Route>

      <Route
        path="/login"
        element={
          <AuthProvider>
            {" "}
            <LoginPage />
          </AuthProvider>
        }
      />
      <Route
        path="/register"
        element={
          <AuthProvider>
            <RegisterPage />
          </AuthProvider>
        }
      />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRouter;
